<template>
        <div v-if="profileInfo">
          <social-sharing :url="shareFbUrl"
            title="Sharpen Founder"
            description=""
            inline-template
            ref="shareFbButton"
            @close="closeModal()">
            <div>
              <network network="facebook">
                <i class="fa fa-facebook" style="display:none"></i>
              </network>
            </div>
          </social-sharing>
          <ModalHolder :title="'Invite others to join'" :is-show="showInvite"
            :closable="true" :mHeight="profileInfo.is_featured || profileInfo.is_demo ? '22vh' : '15vh'" @on-close="seShowtInviteModal(false)">
            <template slot="mheader" class="flex-container direction-row center" style="justify-content:space-between;">
            <div class="order-1"></div>
            <b class="order-2">Invite others to join</b>
            <div class="order-3"></div>
            <img alt=" " @click="closeModal()" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
            </template>
            <template slot="mcontent">
              <div class="invite-content-container">
                <RadioGroup v-model="inviteOption">
                  <!-- <Radio label="facebook">
                    <div>
                      <span>Facebook Post</span>
                    </div>
                  </Radio> -->
                  <Radio label="sms">
                    <div>
                      <span>SMS</span>
                    </div>
                  </Radio>
                  <Radio label="email">
                    <div>
                      <span>Email</span>
                    </div>
                  </Radio>
                </RadioGroup>
              </div>
            </template>
            <template slot="mfooter">
                  <Button size="large" long v-on:click="inviteSelected()" type="primary">Invite</Button>
                </template>
          </ModalHolder>

          <ModalHolder :title="'Invite others to join'" m-width="40%" mScrollable="auto" m-height="100%" :is-show="showSmsEmailModal">
            <template slot="mheader" class="flex-container direction-row center" style="justify-content:space-between;">
              <div class="order-1"></div>
              <b class="order-2">Invite others to join</b>
              <div class="order-3"></div>
              <img alt=" " @click="closeModal()" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
            </template>
            <template slot="mcontent">
              <share-component ref="shareComponent" :shareType='inviteOption' :brandId="brandId" @sendInvitation="closeModal()" v-if="showSmsEmailModal"></share-component>
            </template>
            <template slot="mfooter">
                <Button type="text" @click="cancelEmailSMSModal">Cancel</Button>
            </template>
          </ModalHolder>
        </div>
</template>

<script>
import ShareComponent from '@/views/ShareComponent'
import ModalHolder from "@/components/ModalHolderComponent";
import * as API from '@/endpoints'
export default {
  components:{ShareComponent,ModalHolder},
  data(){
    return{
      // showInviteModal : true,
      showSmsEmailModal : false,
      inviteOption: 'facebook',
    }
  },
  watch: {
    "showInvite": function(n,o) {
      if(n) {
        this.seShowtInviteModal(false)
        this.showSmsEmailModal = true;
      }
    }
  },
  methods:{
    onShare(){
      this.seShowtInviteModal(false)
      this.showSmsEmailModal = true;
    },
    closeModal(){
      this.seShowtInviteModal(false)
      this.showSmsEmailModal = false,
      this.inviteOption= 'facebook'
    },
    cancelEmailSMSModal(){
      this.$refs.shareComponent.resetFields()
      this.seShowtInviteModal(false)
      this.showSmsEmailModal = false
    },
    inviteSelected(){
      switch (this.inviteOption) {
        case 'facebook':
          this.triggerFbShare()
          break;
        case 'sms':
          this.onShare()
          break;
        case 'email':
          this.onShare()
          break
        default:
          break;
      }
    },
    triggerFbShare($event) {
      // this.$store.dispatch('share/getBrandShareInfo', {brand_id: this.singleResource.data.developed_by, user_id: this.profileInfo.id}).then(res => {
        const elem = this.$refs.shareFbButton
        elem.$el.children[0].click()
      // });
    },
    seShowtInviteModal(v){
      this.$store.commit('user/showInviteModal', {showInvite: v, fbShareUrl:this.shareFbUrl})
    }
  },
  computed:{
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    brandId: {
      get() {
        return Cons[0].BRAND_ID
        // return this.$store.state.resource.singleResource.data.developed_by;
      }
    },
    showInvite:{
        get(){
            return this.$store.state.user.invite.showInviteModal
        }
    },
    shareFbUrl:{
        get(){
            if(location.hostname == 'localhost'){
              return ''
            }
            return this.$store.state.user.invite.shareFbUrl ? this.$store.state.user.invite.shareFbUrl : location.protocol + "//" + location.host
        }
    },
  }
}
</script>

<style>

</style>
